import type { IFormInput } from '../../Components/Hooks/Organisms/usePropertyForm'
import { fromUtcToLocalFormatDate } from '../../Components/utils'
import type { OKRes } from '../../Types/Api/Ok'
import type { IPropertyDetail, IPropertyList } from '../../Types/Api/Property'
import { api } from './API'
import { requireAuth } from './Auth'

export const isPropertyList = (data: any): data is IPropertyList => {
  return data.data !== undefined
}

export const findProperties = async (
  tab: string,
  orderBy: string,
  order: string,
  name: string,
  page: number,
  withTrashed: boolean,
) => {
  const res = await requireAuth<IPropertyList>(
    api.get(`properties`, {
      tab,
      order_by: orderBy,
      order,
      name,
      page,
      with_trashed: withTrashed,
    }),
  )

  if (res.ok && isPropertyList(res.data)) {
    return {
      ...res,
      data: {
        ...res.data,
        data: res.data.data.map((property) => ({
          ...property,
          created_at: fromUtcToLocalFormatDate(
            property.created_at,
            'YYYY年MM月DD日 HH:mm A',
          ),
          updated_at: fromUtcToLocalFormatDate(
            property.updated_at,
            'YYYY年MM月DD日 HH:mm A',
          ),
        })),
      },
    }
  }
  return res
}

const isPropertyDetail = (data: any): data is IPropertyDetail => {
  return data.id !== undefined
}

export const findProperty = async (id: string) => {
  const res = await requireAuth<IPropertyDetail>(api.get(`properties/${id}`))

  if (res.ok && isPropertyDetail(res.data)) {
    return {
      ...res,
      data: {
        ...res.data,
        created_at: fromUtcToLocalFormatDate(
          res.data.created_at,
          'YYYY年MM月DD日 HH:mm A',
        ),
        updated_at: fromUtcToLocalFormatDate(
          res.data.updated_at,
          'YYYY年MM月DD日 HH:mm A',
        ),
      },
    }
  }
  return res
}

export const updateProperty = async (
  id: number | string,
  property: IFormInput,
) => {
  const res = await requireAuth<OKRes>(api.put(`properties/${id}`, property))
  return res
}

export const createProperty = async (property: IFormInput) => {
  const res = await requireAuth<IPropertyDetail>(
    api.post(`properties`, property),
  )
  return res
}

export const deleteProperty = async (id: number | string) => {
  const res = await requireAuth<OKRes>(api.delete(`properties/${id}`))
  return res
}
